export default __webpack_public_path__ + "static/media/icon-email.e36c1763.webp";